import { render } from "./component-cywl.vue?vue&type=template&id=490967a1"
import script from "./component-cywl.vue?vue&type=script&lang=js"
export * from "./component-cywl.vue?vue&type=script&lang=js"

import "./component-cywl.vue?vue&type=style&index=0&id=490967a1&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__